import styled from 'styled-components';

export const CoSignerButton = styled.button`
  border: none;
  background-color: inherit;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 390;
  color: var(--cvna-color-blue-2);
  grid-area: ctaButton;
  width: max-content;
`;
